import React from "react";
import {Outlet} from "react-router-dom";

import Page from "../../../layouts/Main/Page";
import {useFeedbackTools} from "../../../components/FeedbackTools";
import {useQuotes} from "../QuotesContext";
import QuoteVariants from "./QuoteVariants";
import QuoteDetails from "./QuoteDetails";

import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import QuoteHeader from "./QuoteHeader";
import DeleteIcon from "@mui/icons-material/Delete";
import MenuDots from "../../../components/MenuDots";
import OriginalRequest from "./OriginalRequest";


const Quote = () => {
    const {
        quoteDialog,
        quotePreviewDialog,
        resetSelectedQuote,
        deleteSelectedQuote,
        selectedQuote: quote,
        isLoadingSelectedQuote: isLoading
    } = useQuotes();

    const {showErrorNotification, showSuccessNotification, askConfirmation} = useFeedbackTools();

    const [tabValue, setTabValue] = React.useState("0");

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleDelete = () => {
        const innerDelete = async () => {
            try{
                await deleteSelectedQuote();
                quoteDialog.close(); // unmount the page and then reset the selected quote
                resetSelectedQuote();
                showSuccessNotification("Preventivo eliminato");
            }catch(e){
                showErrorNotification(e);
            }
        }
        askConfirmation({
            title: "Elimina preventivo",
            description: `Confermi l'eliminazione del preventivo selezionato?`,
            confirmationText: 'Si',
            cancellationText: 'No',
            onConfirm: innerDelete
        });
    }

    const title = `Preventivo ${quote.surname || ""} ${quote.name || ""}`;

    return <>
        <Page title={title}
              disablePadding
              loading={isLoading}
              onBack={quoteDialog.close}
              hidden={quotePreviewDialog.show}
              actions={<MenuDots options={[{label: "Elimina", icon: <DeleteIcon fontSize="small"/>, onClick: handleDelete}]}/>}
              overlay>

            <Container maxWidth="md"
                       disableGutters={true}
                       sx={{mb: 4}}>
                <Stack spacing={3} mt={3}>

                    <QuoteHeader />

                    <TabContext value={tabValue}>
                        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                            <TabList onChange={handleChange}
                                     aria-label="quote tabs"
                                     variant="scrollable"
                                     scrollButtons="auto">
                                <Tab label="Proposta" value="0"/>
                                <Tab label="Dettagli" value="1"/>
                                {
                                    quote.requestId !== null && <Tab label="Richiesta originale" value="2"/>
                                }
                            </TabList>
                        </Box>
                        <TabPanel value="0" sx={{p: 0}}><QuoteVariants quote={quote}/></TabPanel>
                        <TabPanel value="1" sx={{p: 0}}><QuoteDetails quote={quote}/></TabPanel>
                        {
                            quote.requestId !== null && <TabPanel value="2" sx={{p: 0}}><OriginalRequest quote={quote}/></TabPanel>
                        }
                    </TabContext>
                </Stack>
            </Container>

        </Page>
        <Outlet/>
    </>
}

export default Quote;